import MenuIcon from "@mui/icons-material/Menu";
import { Badge, Container, Divider, Stack, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { useContext, useEffect, useRef, useState } from "react";
import AppLogo from "../../assets/images/Trust-telecom-New-Logo.png";
import ProfileMenu from "./ProfileMenu";
import Navlinks from "./Navlinks";
import NotificationBlackIcon from "../../assets/icons/notification-black-icon.png";
import { AppContext } from "../../lib/Context";
import NotificationDialog from "./NotificationDialog";
import { useLocation, useNavigate } from "react-router-dom";
import ChatIcon from "@mui/icons-material/Chat";
import CustomDrawer from "./Drawer";
import { getUnreadNotificationCount } from "../../services/NotificationApi";
import NotificationAudio from "../../assets/audio/notification-sound.mp3";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentNotificationCount } from "../../lib/redux/slices/searchKeysSlice";
// import io from "socket.io-client";

// const socket = io.connect("http://localhost:3000/");

const drawerWidth = 270;

function AppHeader(props) {
  const audioRef = useRef(null);
  const notifyDialogRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { window } = props;
  const { palette } = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { userData } = useContext(AppContext);
  const { pathname } = useLocation();
  const notificationCount = useSelector(
    (state) => state.searchKeysReducer.searchKeys.currentNotificationCount,
  );

  // useEffect(() => {
  //   let intervalID;

  //   if (userData) {
  //     fetchUnreadNotificationCount(notificationCount);

  //     intervalID = setInterval(() => {
  //       fetchUnreadNotificationCount(notificationCount);
  //     }, 15000);
  //   }

  //   return () => {
  //     if (intervalID) clearInterval(intervalID);
  //   };
  // }, [userData]);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const fetchUnreadNotificationCount = async (nfc) => {
    try {
      const response = await getUnreadNotificationCount(userData?._id);
      if (response.data.status === "success") {
        const count = response.data.data;

        dispatch(setCurrentNotificationCount(count));

        if (response.data.data > 0) {
          audioRef.current?.play().catch((err) => {
            console.warn("Audio play failed:", err);
          });
        }
      }
    } catch (error) {}
  };

  return (
    <Box sx={{ display: "flex" }}>
      <audio ref={audioRef} src={NotificationAudio}></audio>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          backgroundColor: palette.secondary.light,
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        }}
      >
        <Container maxWidth={"xl"}>
          <Toolbar
            sx={{ justifyContent: "space-between", padding: { xs: 0, md: 0 } }}
          >
            {/* App logo */}
            <Stack direction={"row"} alignItems={"center"} gap={2}>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                // sx={{ display: { sm: "none" } }}
              >
                <MenuIcon htmlColor="black" />
              </IconButton>
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                width={{ xs: 120, sm: 145 }}
                sx={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                <img src={AppLogo} width={"100%"} height={"100%"} />
              </Box>
            </Stack>

            {/* <Navlinks /> */}
            <Stack direction={"row"} alignItems={"center"} gap={2}>
              <IconButton
                onClick={() =>
                  notifyDialogRef.current.isVisible({
                    fetch: fetchUnreadNotificationCount,
                  })
                }
              >
                <Badge badgeContent={notificationCount} color="primary">
                  <img
                    src={NotificationBlackIcon}
                    alt={"notification-icon"}
                    width={30}
                  />
                </Badge>
              </IconButton>
              <Divider orientation="vertical" variant="middle" flexItem />
              {userData?.designation === "Admin" && (
                <>
                  <IconButton onClick={() => navigate("/customer-support")}>
                    <ChatIcon />
                  </IconButton>
                  <Divider orientation="vertical" variant="middle" flexItem />
                </>
              )}

              <ProfileMenu openNotifyDialog={notifyDialogRef} />
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            // display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <CustomDrawer handleDrawerToggle={handleDrawerToggle} />
        </Drawer>
      </nav>
      <Box component="main" sx={{ width: "100%" }}>
        <Toolbar />
        <Container
          maxWidth={"xl"}
          sx={{
            mt: pathname !== "/customer-support" && 6,
            mb: pathname !== "/customer-support" && 3,
          }}
        >
          {props.children}
        </Container>
      </Box>
      <NotificationDialog ref={notifyDialogRef} />
    </Box>
  );
}

export default AppHeader;
